import type { Pinia } from "pinia";

export default defineNuxtPlugin(async ({ $pinia }) => {
  const { getCurrencies } = useCurrencyStore($pinia as Pinia);
  setInterval(() => {
    getCurrencies(true);
  }, 1000 * 60 * 60);
  await getCurrencies();
});
